export enum EventBusActions {
  filtersChanged = 0,
  branchIdReceived = 1,
  downloadPdf = 2
}
